import React from 'react';
import { FiGithub } from 'react-icons/fi';
import { FaLinkedinIn } from 'react-icons/fa';
const SocialMedia = () => {
	return (
		<div className='app__social'>
			<a
				href='https://www.linkedin.com/in/yaseer-tasleem/'
				target='_blank'
				rel='noopener noreferrer'>
				<div>
					<FaLinkedinIn />
				</div>
			</a>
			<a
				href='https://github.com/yaseer-13'
				target='_blank'
				rel='noopener noreferrer'>
				<div>
					<FiGithub />
				</div>
			</a>
		</div>
	);
};

export default SocialMedia;
